const CustomerChannel = () =>
  import('@/views/main/helper/customerChannel/CustomerChannel.vue')
export default {
  path: '/main/helper/customerChannel',
  name: 'CustomerChannel',
  component: CustomerChannel,
  children: []
}
